<template>
  <div class="cv-templates-container">
    <w-nav-bar nav_title="新建简历" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="template-slide-container">
      <cube-slide :data="templates" :autoPlay="false" @change="changePage">
        <cube-slide-item class="flex" v-for="(item, index) in templates" :key="index">
          <div class="template-block">
            <div class="block-content flex-column">
              <div class="flex-between block-header">
                <span class="name">{{ item.name }}</span>
                <div class="template-lang flex-start">
                  <div class="lang-item flex-center" :class="{'lang-active': currentLang === item.lang}"
                       v-for="(item, index) in item.langAry" :key="index" @click="changeTemplateLang(item)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <img :src="item[`${currentLang}_img`]" alt="">
            </div>
            <p class="template-description">{{ item.temp_desc }}</p>
          </div>
        </cube-slide-item>
        <template slot="dots" slot-scope="props">
          <span class="my-dot" :class="{'active': props.current === index}" v-for="(item, index) in templates.length"
                :key="index"></span>
        </template>
      </cube-slide>
    </div>
    <div class="templates-footer footer flex-between">
      <button class="template-btn white-button more" @click="toPage('more')">更多模板</button>
      <button class="theme-button template-btn use" @click="toPage('use')">使用模板</button>
    </div>
    <!-- <upper-limit-cv :state="continueShow" @handleClose="continueShow = false"/> -->
    <w-popup :state="continueShow" @handleClose="continueShow = false">
      <operation-vip slot="content"  />
    </w-popup>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
  import WPopup from '@/components/global/w-popup'
  import Cookies from 'js-cookie'
	// import upperLimitCv from '../cv-components/upper-limit-cv'
  import operationVip from '../cv-components/operation-vip.vue';
	import { recommendTemps } from '../../assets/json/temps'
	import { mapState, mapActions } from 'vuex'
	import { eventMixin } from '../../assets/js/mixin/global'
	import { cvOperationMixin } from '../../assets/js/mixin/cv'
	import { userMixin } from '../../assets/js/mixin/user'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'cv-templates',
		mixins: [ eventMixin, cvOperationMixin, userMixin, componentsMixin ],
		data () {
			return {
				templates: recommendTemps,
				currentTemplateInfo: recommendTemps[0],
				currentLang: 'cn',
				cvType: 'white',
				continueShow: false,
        _t: ''
			}
		},
		mounted () {
			// this.getTemplateCv()
      this._t = Cookies.get('_t')
    },
		computed: {
			...mapState('cvIndex', [ 'templateCvs', 'cvList' ])
		},
		watch: {},
		components: {
			WNavBar,
			// upperLimitCv,
            operationVip,
            WPopup,
		},
		methods: {
			...mapActions('cv', [ 'getTemplateCv' ]),
			pageBack () {
				this.$router.back()
			},
			// 切换当前简历语言
			changeTemplateLang (item) {
				this.currentLang = item.lang
			},
			// 轮播图切换页面
			changePage (current) {
				// this.cvType = this.templates[current].cv_type
				if (!this.templates[current][`${ this.currentLang }_img`]) {
					this.currentLang = this.currentLang === 'en' ? 'cn' : 'en'
				}
				this.currentTemplateInfo = this.templates[current]
			},
			async toPage (type) {
        let token = this.currentTemplateInfo[`${ this.currentLang }_token`]
				if (type === 'more') {
					window.location.href = `/jianlimoban/tuijian/`
				} else if (await this.verifyCvCreate(this.currentLang, token, this._t)) {
					return 0
				} else if (type === 'use') {
					this.$router.push(`/cvs/${ token }/editor`)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global/variable";
  @import "../../assets/scss/global/mixin";
  .cv-templates-container {
    width: 100vw;
    height: $screen-height;
    background-color: #F5F5F7;
    padding-top: 44px;
    .template-slide-container {
      margin-top: 24px;
      .cube-slide {
        height: calc(calc(var(--vh, 1vh) * 100) - 164px);
        .cube-slide-item {
          justify-content: center;
          height: 100%;
          .template-block {
            width: 80vw;
            .block-content {
              background-color: $color-light;
              border-radius: 12px;
              box-shadow: 0 2px 10px 0 rgba($color: #C8C8D3, $alpha: .6);
              margin-bottom: 18px;
              height: 422px;
              align-items: center;
              padding-bottom: 12px;
              .block-header {
                width: 100%;
                height: 44px;
                border-bottom: 1px solid #F5F5F7;
                padding: 0 22px;
                .name {
                  color: $color-title;
                  font-size: $font-size-medium-x;
                }
                .lang-item {
                  width: 42px;
                  height: 24px;
                  border-radius: 2px;
                  color: #50a4ff;
                  border: 1px solid #50a4ff;
                  margin-right: 10px;
                  font-size: $font-size-small;
                  &:last-child {
                    margin-right: 0;
                  }
                }
                .lang-active {
                  color: $color-light;
                  background-color: #50a4ff;
                }
              }
            }
            img {
              width: 90%;
            }
            .template-description {
              width: 80vw;
              white-space: pre-wrap;
              line-height: 24px;
              color: $color-dark-gray;
            }
          }
        }
        /deep/ .cube-slide-dots {
          .my-dot {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #C4C4C6;
            margin-right: 10px;
            &:last-child {
              margin-right: 0;
            }
          }
          .active {
            background-color: $color-theme;
          }
        }
      }
    }
    .templates-footer {
      width: 100vw;
      padding: 0 24px;
      @include ipx-footer(78px, 1px);
      .template-btn {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        line-height: 22px;
        font-size: $font-size-medium-x;
      }
      .more {
        flex: 1;
        margin-right: 16px;
        background-color: transparent;
      }
      .use {
        flex: 2;
      }
    }
  }
</style>
